<template>
    <div class="int_appendix">
        <div class="appendix_title">Download</div>
        <div class="appendix_listall">
            <!--附件列表標題-->
            <div class="appendix_listitle">
                <div class="appendix_list_item">No.</div>
                <div class="appendix_list_name">Title</div>
            </div>
            <!--附件列表內容-->
            <div class="appendix_listbar" v-for="(item,index) in fileData" v-bind:key="item.id">
                <template v-if="item.fileExt != 'pdf'">
                    <!--其他檔案處理辦法-->
                    <a :href="'/filestore/' +className+'/'+ getOrgName(item.filePath) + '/true/'+getDownloadName(item)" :title="item.filename" target="_blank" rel="noopener noreferrer" :download="getDownloadName(item)">
                    <div class="appendix_list_item">{{ index+1 }}</div>
                    <div class="appendix_list_name">{{ item.fileName }}</div>
                </a>
                </template>
                <template v-else>
                    <!--PDF檔案處理辦法-->
                    <a :href="'/filestore/' +className+'/'+ getOrgName(item.filePath) + '/true/'+getDownloadName(item)" :title="item.filename" target="_blank" rel="noopener noreferrer">
                    <div class="appendix_list_item">{{ index+1 }}</div>
                    <div class="appendix_list_name">{{ item.fileName }}</div>
                    </a>
                </template>
            </div>
        </div>
    </div>
</template>
<script>
export default{
    props:{
        //附件下載清單
        fileData:{
            type:Array,
            default: () => [],
        },
        className:{
            type:String,
            default:"",
        }
    },
    data(){

    },
    methods:{
        getOrgName(filePath){
            const path = filePath.trim().replace(/\\/g, "/");
            return path.substring(path.lastIndexOf("/") + 1);
        },
        getDownloadName(fileItem){
            return fileItem.fileName;
        }
    }
}
</script>